export type DateRangePickerProps = {
  filterName: string;
  initialStartDate?: Date;
  initialEndDate?: Date;
  onDatesEntered: (startDate: Date, endDate: Date) => void;
};

export { default as DateRangePicker } from './DateRangePicker';
